import request from '../../utils/request'

export function fetchList (data) {
  return request.post('/business/order/page', data, { trim: true })
}

export function queryById (id) {
  return request.get(`/business/order/${id}`)
}

export function deleteById (id) {
  return request.get(`/business/order/delete/${id}`)
}

export function exportDetail (id) {
  return request.get(`/business/order/exportDetail/${id}`, { download: true })
}
